export function splitUserName(fullName: string): { firstName: string; lastName: string } {
 
    if (!fullName) return { firstName: '', lastName: '' };
    const parts = fullName.trim().split(/\s+/);
     
      const firstName = parts[0].slice(0, 1).toUpperCase();
      const lastName = parts[0].slice(1, 2).toUpperCase();
    return {
      firstName:firstName,
      lastName: lastName,
    };
  }